module.exports = __webpack_public_path__ + "static/media/gray-up-arrow.87082e43.svg";